module.exports = __webpack_public_path__ + "ab07f39328e2ffc62907a7151d41f636.svg";